const convertDateFormat = (dateString) => {
  if (dateString) {
    const dateObj = new Date(dateString);
    return dateObj.toLocaleDateString("en-US");
  } else {
    return "";
  }
};


export const drugTestScheduleTableTitle = [
  { title: "Test Date", date: true, dataType: "string" },
  { title: "Test Time", dataType: "string" },
  { title: "Test Slot", dataType: "number" },
  { title: "Location", dataType: "string" },
  { title: "Agency Name", dataType: "string" },
  { title: "Offender Number", dataType: "string" },
  { title: "Alt ID", dataType: "string" },
  { title: "Person Name", dataType: "string" },
  { title: "Test Frequency", dataType: "string" },
  { title: "Last Test", date: true, dataType: "string" },
  { title: "Supervisor", dataType: "string" },
  { title: "Last Name", dataType: "string" },
  { title: "DOB", date: true, dataType: "string" },
  { title: "Last Log Message", dataType: "string" },
  { title: "Gender", dataType: "string" },
  { title: "Phone", dataType: "string" },
  { title: "Warrant", dataType: "string" },
  { title: "Checked In", bool: true, dataType: "boolean" },
  { title: "Void", bool: true, dataType: "boolean" },
];


export const createsTestDatesTableTitle = [
  { title: "Date", date: true },
  { title: "Day" },
  { title: "Slot 1", bool: true, testDateCheckBox1: true },
  { title: "Slot 2", bool: true, testDateCheckBox2: true },
  { title: "Slot 3", bool: true, testDateCheckBox3: true },
  { title: "Slot 4", bool: true, testDateCheckBox4: true },
  { title: "Week" },
];

export const setDrugTestScheduleTableColumnData = (data) => {
  const arr = [];
  data.map((val, i) => {
    arr.push({
      "Test Date": convertDateFormat(val?.sTestDate),
      "Test Time": val?.sTestTime,
      "Test Slot": val?.iSlot,
      Location: val?.sTestLocation,
      "Agency Name": val?.sAgencyName ?? "",
      "Offender Number": val?.sOffenderNumber,
      "Alt ID": val?.sOffenderNumberPIN ?? "",
      "Person Name": val?.sLastFirst,
      "Test Frequency": val?.sFrequencyName,
      "Last Test": val?.dLastTest ? convertDateFormat(val.dLastTest) : null,
      Supervisor: val?.sPrimarySupervisorName,
      "Last Name": val?.sLastName,
      DOB: convertDateFormat(val?.dDOB),
      "Last Log Message": val?.sLogMessage,
      Gender: val?.sGender,
      Phone: val?.sPhone,
      Warrant: val?.a,
      "Checked In": val?.bCheckedIn ?? false,
      Void: val?.bVoid,
      gDocketID: val?.gDocketID,
      gDrugTestRandomizerId: val?.gDrugTestRandomizerId,
      gDrugTestRandomizerScheduleId: val?.gDrugTestRandomizerScheduleId,
      gPersonID: val?.gPersonID,
      gTestDateId: val?.gTestDateId,
      gEntryUserId: val?.gEntryUserId,
      ID: i,
    });
  });
  return arr;
};
